import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import fileReducer from "./fileSlice"
import formReducer from "./formInitialSlice"
import verificationBookingValues from "./formInitialBookingSlice";
import verificationShipmentValues from "./formInitialShipmentSlice";
import addVehicleReducer from "./addNewVehiclesSlice";
import vehicleInfoReducer from "./vehicleInfoSlice"
import fetchDataReducser from "./fetchDataSlice"
import vehicleCountReducser from "./countSlice"
import manageReducer from "./manageSlice";
import manageV2Reducer from "./manageSliceV2";

import userDataReduser from "./userDataSlice";
import logsSliceReducser from "./logsSlice";
import parentReducer from "./parentSlice"
import toastReducer from "./toastSlice";
import excelContainerRedUcer from "./fetchExcelContainerSlice";
import containerCountSlice from "./containerCountSlice";
import clientViewInitialSlice from "./clientViewInitialSlice"
import settingsSlice from "./settingsSlice";
import taskSlice from "./taskSlice";

export default combineReducers({
    user: userReducer,
    files: fileReducer,
    form: formReducer,
    add: addVehicleReducer,
    vehicleInfo: vehicleInfoReducer,
    fetchData: fetchDataReducser,
    fetchCount: vehicleCountReducser,
    manage: manageReducer,
    userData: userDataReduser,
    logsData: logsSliceReducser,
    parentData: parentReducer,
    toast: toastReducer,
    excelContainer : excelContainerRedUcer,
    containerCount: containerCountSlice,
    clientViewInitial : clientViewInitialSlice,
    verificationBooking: verificationBookingValues,
    verificationShipment: verificationShipmentValues,
    manageV2: manageV2Reducer,
    settings: settingsSlice,
    task: taskSlice

})